import React, { useEffect, useRef, useState } from "react";
// import HeroImage from "../../assets/images/landing-hero.png";
// import LandingSection2 from "../../assets/images/landing-section-2.png";
import LandingSection3 from "../../assets/images/landing-section-3.png";
import { routesConfig } from "../../configs/routes";
import { NavLink } from "react-router-dom";
import { Icons } from "../../assets/icons";
import { getSection1 } from "../../api/landingPage/section1";
import { getSection2 } from "../../api/landingPage/section2";
import { Button } from "../../components/ui/button";
import { getSection3 } from "../../api/landingPage/section3";
import { getSection4 } from "../../api/landingPage/section4";
import { getSection5 } from "../../api/landingPage/section5";
import { getSection6 } from "../../api/landingPage/section6";
// import { getSection7 } from "../../api/landingPage/section7";
import Footer from "../../components/footer";
import VideoPlayer from "../../components/videoPlayer";
import RedirectPopup from "../../components/redirectPopup";
//@ts-ignore
import captions from "../../assets/transcript/catalyze.vtt";
import { convertVttToTranscript, TranscriptEntry } from "../../utils/vttParser";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";
// import { Caption, parseVTT } from "../../utils/vttParser";

const LandingPage = () => {
  useDocumentTitle("Home");
  const [loading1, setLoading1] = useState(true);
  const [loading2, setLoading2] = useState(true);
  const [loading3, setLoading3] = useState(true);
  // const [loading4, setLoading4] = useState(true);
  const [loading5, setLoading5] = useState(true);
  const [loading6, setLoading6] = useState(true);
  // const [loading7, setLoading7] = useState(true);
  const [data1, setData1] = useState<any>();
  const [data2, setData2] = useState<any>();
  const [data3, setData3] = useState<any>();
  // const [data4, setData4] = useState<any>();
  const [data5, setData5] = useState<any>();
  const [data6, setData6] = useState<any>();
  // const [data7, setData7] = useState<any>();
  const [isPlaying, setIsPlaying] = useState(false);
  const [captionsText, setCaptionsText] = useState<TranscriptEntry[]>([]);
  const [showTranscript, setShowTranscript] = useState(false);
  const videoRef = useRef(null);

  const handlePlayButtonClick = () => {
    //@ts-ignore
    videoRef.current.play();
    setIsPlaying(true);
  };

  // const benefits = [
  //     "Eli Lilly backing",
  //     "Over 20 year of experience with over 100 assets",
  //     "Strong network across the industry for best in class vendors and capabilities",
  // ];
  const fetchData = () => {
    getSection1().then((res) => {
      setData1(res.data);
      setLoading1(false);
    });
    getSection2().then((res) => {
      setData2(res.data);
      setLoading2(false);
    });
    getSection3().then((res) => {
      setData3(res.data);
      setLoading3(false);
    });
    // getSection4().then((res) => {
    //   setData4(res.data);
    //   setLoading4(false);
    // });
    getSection5().then((res) => {
      setData5(res.data);
      setLoading5(false);
    });
    getSection6().then((res) => {
      setData6(res.data);
      setLoading6(false);
    });
    // getSection7().then((res) => {
    //     setData7(res.data);
    //     setLoading7(false);
    // });
  };
  const fetchVTT = async () => {
    try {
      const response = await fetch(captions); // Path relative to public folder
      const vttContent = await response.text();
      // const parsedCaptions = parseVTT(vttContent);
      const parsedCaptions = convertVttToTranscript(vttContent);
      setCaptionsText(parsedCaptions);
    } catch (error) {
      console.error("Error loading VTT file:", error);
    }
  };
  useEffect(() => {
    fetchData();
    fetchVTT();
  }, []);
  return (
    <>
      <div className="md:py-12 py-4 m-auto">
        {!loading1 && (
          <section id="hero" className="mb-8 md:mb-0">
            <div className="">
              <div className="grid grid-cols-8 gap-4 relative">
                <div className="md:col-span-3 col-span-8 md:px-12 px-4">
                  <h1>
                    <div className="lg:text-5xl md:text-4xl text-[2rem] font-bold xl:leading-[4.5rem] lg:leading-[4rem] md:leading-[3.25rem] leading-10">
                      {data1?.Header_highlighted}&nbsp;
                      {/* Accelerating your science to patients&nbsp; */}
                      <span className="font-light">
                        {data1?.Header_non_highlighted}
                        {/* by sharing best-in-class capabilities. */}
                      </span>
                    </div>
                  </h1>

                  <div className="text-base font-normal tracking-tight my-4">
                    {data1?.Description}
                    {/* We streamline processes, enhance patient
                                    recruitment, and optimize trial designs,
                                    helping to bring new therapies to market
                                    faster and improve data quality for better
                                    patient outcomes. */}
                  </div>
                </div>
                <div className="lg:col-span-2 md:col-span-3 col-span-8 md:px-12 px-4">
                  <div className="">
                    {routesConfig.map(
                      (menu, index) =>
                        menu.name && (
                          <NavLink
                            key={index}
                            className={`border rounded-[4px] border-border px-4 py-2 md:p-4 md:h-36 md:w-44 text-body-text-lilly_red flex md:flex-col md:justify-between gap-2 hover:scale-105 transition-all mx-auto ${index < routesConfig.length - 2 ? "md:mb-4 mb-6" : ""}`}
                            to={menu.path}
                            data-gtm-id="item-29"
                          >
                            <div className="md:flex items-center justify-between hidden">
                              <div className="text-base font-bold w-fit">
                                {menu.name}
                              </div>

                              {Icons?.ArrowRight && (
                                <Icons.ArrowRight strokeWidth={3} />
                              )}
                            </div>
                            {menu.icon && <div>{menu.icon}</div>}
                            <div className="md:hidden flex items-center justify-between w-full">
                              <div className="text-base w-fit">{menu.name}</div>

                              <div>
                                {Icons?.ArrowRight && (
                                  <Icons.ArrowRight strokeWidth={1.8} />
                                )}
                              </div>
                            </div>
                          </NavLink>
                        ),
                    )}
                  </div>
                </div>
                <div className="lg:col-span-3 md:col-span-2 col-span-8 relative h-full md:my-0 my-8 lg:pr-12">
                  {/* <img src={HeroImage} alt="hero-image" /> */}
                  <img
                    className="max-h-[39rem] h-full xl:w-full object-cover md:rounded-[6px]"
                    src={`${process.env.REACT_APP_API_BASE_URL}${data1?.Image.url}`}
                    alt={data1?.Image?.alternativeText ?? "Hero Image"}
                  />
                </div>
              </div>
            </div>
          </section>
        )}
        {!loading2 && (
          <section className="md:py-12 py-8">
            <div className="relative">
              <div className="">
                <div className="grid grid-cols-5 xl:gap-24 lg:gap-12 items-center">
                  <div className="md:col-span-2 md:block hidden h-full">
                    <img
                      // src={LandingSection2}
                      src={`${process.env.REACT_APP_API_BASE_URL}${data2?.Image.url}`}
                      alt={
                        data2?.Image?.alternativeText ??
                        "Scientist in a lab coat working on a laptop in a laboratory setting"
                      }
                      className="h-full object-cover md:rounded-r-[6px]"
                    />
                  </div>

                  <div className="md:col-span-3 col-span-5 md:px-12 px-4">
                    <div className="md:text-3xl text-2xl font-bold tracking-tight md:leading-[3rem] leading-8 md:max-w-[18em]">
                      {data2?.Header}
                      {/* The tomorrow of pharmaceuticals relies on
                                    the ability to transform the way we create
                                    and develop life-changing medications. */}
                    </div>
                    <div className="text-base font-normal my-4 max-w-[40em]">
                      {data2?.Description}
                      {/* ExploR&D is an innovative arm of Eli Lilly
                                    aimed at advancing pharmaceutical research
                                    and development. By utilizing cutting-edge
                                    technologies and methodologies, it seeks to
                                    identify and create new therapeutic
                                    solutions for unmet medical needs, while
                                    fostering collaboration and scientific
                                    excellence to accelerate the discovery of
                                    transformative treatments for patients
                                    globally. */}
                    </div>
                    <div>
                      <div className="text-xl font-normal md:mt-8 md:mb-4 mb-2">
                        {data2?.List_header}
                        {/* Benefits of Partnering With Us */}
                      </div>
                      <div className="text-base font-semibold ml-5">
                        <ul>
                          {data2?.Benefits.map((el: any, index: number) => (
                            <li
                              className="md:leading-8 md:my-0 my-2"
                              key={"section2" + el.benefit + index}
                            >
                              {el.benefit}
                            </li>
                          ))}
                        </ul>
                        {/* <ul>
                                            {benefits.map((el) => (
                                                <li className="leading-8">
                                                    {el}
                                                </li>
                                            ))}
                                        </ul> */}
                      </div>
                    </div>
                  </div>

                  <div className="md:hidden col-span-5 h-full mt-12">
                    <img
                      src={`${process.env.REACT_APP_API_BASE_URL}${data2?.Image.url}`}
                      alt={data2?.Image?.alternativeText ?? "Section 2 Image"}
                      className="h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {!loading3 && (
          <section className="md:py-12 py-8">
            <div className="relative">
              <div className="grid grid-cols-4 md:gap-16 gap-8 items-center">
                <div className="md:col-span-3 col-span-4 md:pl-12 px-4">
                  <div className="grid grid-cols-6 gap-8">
                    <div className="flex xl:col-span-3 col-span-6">
                      <div
                        className="md:text-[7rem] text-[5rem] font-bold text-body-text-lilly_red_light md:leading-[5rem] leading-[4rem] mr-4"
                        style={{
                          fontFamily: "Times New Roman, Times, serif",
                        }}
                      >
                        {data3.Number_of_items}
                      </div>

                      <div className="md:text-3xl text-2xl font-bold tracking-tight md:leading-10 max-w-96">
                        {data3.Header}
                      </div>
                    </div>
                    <div className="xl:col-span-3 col-span-6 xl:border-l border-border-gray20 xl:pl-8">
                      <div className="text-base font-normal">
                        {data3?.Description}
                      </div>
                      <div className="text-base font-bold my-4">
                        {data3?.Sub_header}
                      </div>

                      <RedirectPopup
                        link="https://investor.lilly.com/news-releases/news-release-details/lilly-announces-acquisition-cgrp-antibody-migraine-prevention"
                        target="_blank"
                        rel="noopener noreferrer"
                        arialabel="investor lilly news (opens in new tab)"
                        content={
                          <div className="flex gap-2 items-center md:justify-start justify-between w-full md:w-fit border border-border-lilly_red bg-background hover:bg-accent hover:text-accent-foreground text-body-text-lilly_red px-4 py-2 text-sm font-medium">
                            {data3?.Button_text}
                            <Icons.ArrowRight />
                          </div>
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="md:col-span-1 col-span-4 h-full">
                  <img
                    src={`${process.env.REACT_APP_API_BASE_URL}${data3?.Image.url}`}
                    alt={
                      data3?.Image?.alternativeText ??
                      "Close-up of laboratory glassware and vials arranged on a lab bench"
                    }
                    className="md:h-full w-full md:w-auto object-cover float-right md:rounded-l-[6px]"
                  />
                </div>
              </div>
            </div>
          </section>
        )}

        {!loading5 && (
          <section className="md:py-12 py-8">
            <div className="md:px-12 px-4">
              <div
                id="video-title"
                className="md:text-3xl text-2xl font-bold leading-10 md:tracking-tight my-8"
              >
                {data5.Header}
              </div>
              <div className="grid grid-cols-4 gap-8 items-start w-full 2xl:max-w-[90rem] mx-auto">
                <div className="2xl:col-span-3 col-span-4 relative object-cover w-full">
                  <div className="relative">
                    <div className="w-full h-full">
                      <VideoPlayer
                        videoUrl={`${process.env.REACT_APP_API_BASE_URL}${data5.Video.url}`}
                        captionsUrl={captions}
                        altText={data5.Video.alternativeText}
                        captionsLang="en"
                        initialPlaybackRate={1}
                      />
                    </div>
                  </div>
                </div>
                <div className="2xl:col-span-1 col-span-4 border border-border-gray20 py-4 h-full flex flex-col">
                  <div className="flex justify-between items-center px-6">
                    <div
                      id="transcript-heading"
                      className="md:text-2xl text-xl font-medium leading-8 md:tracking-tight"
                    >
                      Transcript
                    </div>
                    <button
                      onClick={() => setShowTranscript(!showTranscript)}
                      className="text-sm text-body-text-lilly_red flex items-center gap-2 2xl:hidden"
                      aria-label={
                        showTranscript ? "Hide Transcript" : "Show Transcript"
                      }
                      data-gtm-id="item-51"
                    >
                      {showTranscript ? "Hide" : "Show"}
                      {showTranscript ? (
                        <Icons.ChevronUp size={16} />
                      ) : (
                        <Icons.ChevronDown size={16} />
                      )}
                    </button>
                  </div>

                  <div
                    className={`my-4 transition-all duration-300 ease-in-out ${showTranscript ? "block" : "hidden"} 2xl:hidden`}
                  >
                    <div className="max-h-[30rem] overflow-y-auto px-6">
                      {captionsText.map((el, index) => (
                        <div key={index} className="mb-2 text-sm">
                          {el.speaker && (
                            <span className="font-medium">
                              {el.speaker}:&nbsp;
                            </span>
                          )}
                          {el.speech}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div
                    className={`my-4 hidden 2xl:block`}
                    role="region"
                    aria-labelledby="transcript-heading"
                    tabIndex={0}
                    aria-live="polite"
                  >
                    <div className="max-h-[30rem] overflow-y-auto px-6">
                      {captionsText.map((el, index) => (
                        <div key={index} className="mb-2 text-sm">
                          {el.speaker && (
                            <span className="font-medium">
                              {el.speaker}:&nbsp;
                            </span>
                          )}
                          {el.speech}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="2xl:col-span-1 col-span-4">
                  <NavLink
                    to="testimonials"
                    className="flex w-full gap-2 items-center md:justify-start justify-between"
                    aria-label="Our Testimonials"
                    data-gtm-id="item-17"
                  >
                    <div className="flex gap-2 items-center md:justify-start justify-between w-full md:w-fit border border-border-lilly_red bg-background hover:bg-accent hover:text-accent-foreground text-body-text-lilly_red px-4 py-2 text-sm font-medium">
                      Our Testimonials
                      <Icons.ArrowRight />
                    </div>
                  </NavLink>
                </div>
              </div>
            </div>
          </section>
        )}
        {!loading6 && (
          <section className="md:py-12 py-8">
            <div className="relative grid grid-cols-6 gap-8">
              <div className="md:px-12 px-4 md:col-span-4 col-span-6 pb-8 md:pb-0">
                <div className="md:text-3xl text-2xl font-bold leading-10 tracking-tight mb-8">
                  {data6.Header}
                </div>
                <div className="flex flex-col lg:flex-row md:gap-12">
                  <div className="lg:w-1/2 w-full">
                    {data6.Capabilities.map(
                      (capability: any, index: number) => (
                        <>
                          {index % 2 === 0 && (
                            <div key={capability.Header + index}>
                              <div className="lg:text-2xl text-xl font-medium mt-8 mb-4">
                                {capability.Header}
                              </div>
                              {capability.Capabilities.map(
                                (capabilityText: any, index2: number) => (
                                  <div
                                    className={`w-full flex items-center py-4  h-fit ${index2 === 0 ? "border-y" : "border-b"} border-border-gray20 text-base font-normal tracking-tight`}
                                    key={
                                      capability.Header + index + "-" + index2
                                    }
                                  >
                                    {capabilityText.String}
                                  </div>
                                ),
                              )}
                            </div>
                          )}
                        </>
                      ),
                    )}
                  </div>
                  <div className="lg:w-1/2 w-full">
                    {data6.Capabilities.map(
                      (capability: any, index: number) => (
                        <>
                          {index % 2 === 1 && (
                            <div key={capability.Header + index}>
                              <div className="lg:text-2xl text-xl font-medium mt-8 mb-4">
                                {capability.Header}
                              </div>
                              {capability.Capabilities.map(
                                (capabilityText: any, index2: number) => (
                                  <div
                                    className={`w-full flex items-center py-4 h-fit ${index2 === 0 ? "border-y" : "border-b"} border-border-gray20 text-base font-normal tracking-tight`}
                                    key={
                                      capability.Header + index + "-" + index2
                                    }
                                  >
                                    {capabilityText.String}
                                  </div>
                                ),
                              )}
                            </div>
                          )}
                        </>
                      ),
                    )}
                  </div>
                </div>
                <div className="mt-8">
                  <NavLink
                    to="/capabilities"
                    className="flex w-full gap-2 items-center md:justify-start justify-between"
                    aria-label="Capability Details"
                    data-gtm-id="item-18"
                  >
                    <div className="flex gap-2 items-center md:justify-start justify-between w-full md:w-fit border border-border-lilly_red bg-background hover:bg-accent hover:text-accent-foreground text-body-text-lilly_red px-4 py-2 text-sm font-medium">
                      Capability Details
                      <Icons.ArrowRight />
                    </div>
                  </NavLink>
                </div>
              </div>

              <div className=" lg:block md:col-span-2 col-span-6">
                <img
                  src={`${process.env.REACT_APP_API_BASE_URL}${data6?.Image.url}`}
                  alt={data6?.Image?.alternativeText ?? "Capabilities Image"}
                  className="w-full h-full xl:h-auto lg:max-h-[75rem] xl:max-h-[65rem] object-cover xl:float-right md:rounded-l-[6px]"
                />
              </div>
            </div>
          </section>
        )}
      </div>
      <Footer />
    </>
  );
};

export default LandingPage;
